module.exports = __webpack_public_path__ + "static/media/search.a1755588.svg";